import axios from 'axios';
import axiosRetry from 'axios-retry';


class API {
  constructor() {
    axiosRetry(
      axios,
      {
        retries: 3,
        retryDelay: (retryCount) => {
          return retryCount * 1000;
        }
      });
  }

  getNamesFromSpreadsheet(data) {
    // Would it make sense to do this without sending it to php?
    return new Promise((resolve, reject) => {
      axios.post('/api/children/getNamesFromSpreadsheet/', data)  //{headers: {'Content-Type': 'multipart/form-data'}}
        .then(resp => {
          let data = resp.data;
          if (!data.status) {
            reject(data);
          }
          resolve(data);
        })
        .catch(() => {
          reject({
            responseJSON: {
              error: {
                message: "Connection error"
              }
            }
          });
        });
    });
  }
}

// Singleton
let api = new API();
export default api;
